import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchNaturaSftpMonitorToken, uploadIdoc } from '../../../services/naturaSftpMonitorServices'
import ResultPanel from './components/ResultPanel'

export default function CreateOrderPage() {
    const { t } = useTranslation()
    const [file, setFile] = useState(null)
    const [status, setStatus] = useState('idle')   // idle | uploading | success | error
    const [result, setResult] = useState(null)
    const [error, setError] = useState(null)

    const handleSubmit = async () => {
        if (!file) return
        setStatus('uploading'); setError(null); setResult(null)
        try {
            const { token } = await fetchNaturaSftpMonitorToken()
            const data = await uploadIdoc(file, token)
            setResult(data); setStatus('success')
        } catch (e) {
            const payload = e?.response?.data
            setError(
                payload?.cubbo_api_response?.error ||
                payload?.message ||
                payload?.error ||
                e.message
            )
            setStatus('error')
        }
    }

    return (
        <div className="p-6 max-w-3xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">{t('natura_operations.create_order.title')}</h1>

            <section className="bg-gray-50 border border-gray-200 rounded p-4 mb-6">
                <h2 className="font-semibold mb-2">📋 {t('natura_operations.create_order.instructions_heading')}</h2>
                <ol className="list-decimal pl-6 text-sm space-y-1">
                    <li>{t('natura_operations.create_order.instructions_step1')}</li>
                    <li>{t('natura_operations.create_order.instructions_step2')}</li>
                    <li>{t('natura_operations.create_order.instructions_step3')}</li>
                    <li>{t('natura_operations.create_order.instructions_step4')}</li>
                </ol>
                <p className="mt-3 text-sm text-amber-700">⚠️ {t('natura_operations.create_order.warning')}</p>
            </section>

            <div className="mb-4">
                <label htmlFor="idoc-file" className="block border-2 border-dashed border-gray-300 rounded p-6 text-center cursor-pointer hover:border-gray-400">
                    <input
                        id="idoc-file"
                        type="file"
                        accept=".txt,.csv"
                        aria-label="file"
                        className="hidden"
                        onChange={(e) => {
                            const selected = e.target.files?.[0]
                            if (!selected) return
                            setFile(selected)
                        }}
                    />
                    <span className="text-sm text-gray-600">
                        {file ? file.name : t('natura_operations.create_order.file_picker_hint')}
                    </span>
                </label>
            </div>

            <button
                onClick={handleSubmit}
                disabled={!file || status === 'uploading'}
                className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-white"
            >
                {status === 'uploading' ? t('natura_operations.create_order.submit_loading') : t('natura_operations.create_order.submit')}
            </button>

            {status === 'success' && <ResultPanel result={result} />}
            {status === 'error' && (
                <div className="mt-6 p-4 border border-red-200 bg-red-50 rounded text-sm text-red-800">
                    {error}
                </div>
            )}
        </div>
    )
}
